import { http } from './http';
import type {
  BoardDesignResult,
  CalcGenerateRequest,
  CalcGenerateResponse,
  GenerateBoardRequest,
  GenerateBoardResponse,
  HealthcheckResponse,
  ProjectInput,
  ProjectSummary,
} from '@/types/api';

export type DesignArtifactKind =
  | 'single_line_preview'
  | 'mounting_preview'
  | 'single_line_dxf'
  | 'mounting_dxf';

// ─── Endpoints ──────────────────────────────────────────────────────────────
// Names mirror the spec's `*_endpoint` contracts so cross-referencing is easy.

export const endpoints = {
  health: () => http.publicGet<HealthcheckResponse>('/health'),

  listProjects: () => http.get<ProjectSummary[]>('/projects'),

  getProject: (projectId: number) =>
    http.get<ProjectInput>(`/projects/${projectId}`),

  generateBoard: (projectId: number, body: GenerateBoardRequest) =>
    http.post<GenerateBoardResponse>(`/projects/${projectId}/generate`, body),

  calcGenerate: (body: CalcGenerateRequest) =>
    http.publicPost<CalcGenerateResponse>('/calc/generate', body),

  getDesign: (designId: string) =>
    http.get<BoardDesignResult>(`/designs/${designId}`),

  designArtifactPath: (designId: string, kind: DesignArtifactKind) =>
    `/designs/${designId}/artifacts/${kind}`,
  getSvgBlob: (path: string) => http.blob(path),
  getArtifactBlob: (path: string, accept: string) => http.blob(path, { accept }),
};
